<template>
  <div id="appNavbar">
    <ServerError v-if="ServerError" />
    <v-navigation-drawer v-model="sideNav" fixed temporary color="#202020">
      <v-layout wrap justify-center v-if="appType == 'Client'">
        <v-flex
          xs12
          v-for="(item, i) in stylCategories"
          :key="i"
          text-center
          pa-2
          pl-4
          text-uppercase
          align-self-center
        >
          <v-layout wrap justify-center>
            <v-flex xs12>
              <span
                :style="
                  $route.query.styl == item._id
                    ? {
                        'font-family': 'ibmbold',
                      }
                    : {
                        'font-family': 'ibmthin',
                      }
                "
                style="
                  font-size: 15px;
                  color: #ffffff;
                  letter-spacing: 3px;
                  cursor: pointer;
                "
                @click="changeStylRoute(item)"
              >
                {{ item.name }}
              </span>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center v-if="appType == 'Seller'">
        <v-flex
          xs12
          v-for="(item, i) in sellerNavItems"
          :key="i"
          text-center
          pa-2
          pl-4
          text-uppercase
          align-self-center
        >
          <v-layout wrap justify-center>
            <v-flex xs12>
              <router-link :to="item.route">
                <span
                  :style="
                    $route.path == item.route
                      ? {
                          'font-family': 'ibmbold',
                        }
                      : {
                          'font-family': 'ibmthin',
                        }
                  "
                  style="
                    font-size: 15px;
                    color: #ffffff;
                    letter-spacing: 3px;
                    cursor: pointer;
                  "
                >
                  {{ item.name }}
                </span>
              </router-link>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 text-center pa-2 pl-4 text-uppercase align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs12>
              <span
                @click="appLogout"
                style="
                  font-family: ibmthin;
                  font-size: 15px;
                  color: #ffffff;
                  letter-spacing: 3px;
                  cursor: pointer;
                "
              >
                Logout
              </span>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="sideNav2"
      fixed
      temporary
      class="hidden-lg-and-up"
      color="#202020"
      right
    >
      <v-layout wrap justify-center>
        <v-flex
          xs12
          v-for="(item, i) in categories"
          :key="i"
          text-center
          pa-2
          pl-4
          text-uppercase
          align-self-center
        >
          <v-layout wrap justify-center>
            <v-flex xs12>
              <span
                v-if="
                  item.name == 'Men' ||
                  item.name == 'Women' ||
                  item.name == 'Kids' ||
                  item.name == 'Offer' ||
                  item.name == 'Onam Sale'
                "
                @click="changeRoute(item)"
              >
                <span
                  :style="
                    $route.query.category == item._id ||
                    $route.query.type == item.name
                      ? {
                          'font-family': 'ibmbold',
                        }
                      : {
                          'font-family': 'ibmlight',
                        }
                  "
                  style="font-size: 15px; color: #ffffff; letter-spacing: 2px"
                >
                  {{ item.name }}
                </span>
              </span>
              <router-link v-else :to="'/' + item.name">
                <span
                  style="
                    font-family: ibmlight;
                    font-size: 15px;
                    color: #ffffff;
                    letter-spacing: 2px;
                  "
                  >{{ item.name }}
                </span>
              </router-link>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex
          xs12
          v-for="(item, i) in navItems"
          :key="i"
          text-center
          pa-2
          pl-4
          text-uppercase
          align-self-center
          link
        >
          <router-link :to="item.route">
            <v-layout wrap justify-center>
              <v-flex xs12>
                <span
                  style="
                    font-family: ibmlight;
                    font-size: 15px;
                    color: #ffffff;
                    letter-spacing: 2px;
                  "
                  >{{ item.name }}</span
                >
              </v-flex>
              <v-flex xs12 pt-2>
                <v-divider color="#fff"></v-divider>
              </v-flex>
            </v-layout>
          </router-link>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex
          v-if="!appLogin"
          xs12
          text-center
          pa-2
          pl-4
          text-uppercase
          align-self-center
        >
          <router-link to="/Login">
            <v-layout wrap justify-center>
              <v-flex xs12>
                <span
                  style="
                    font-family: ibmlight;
                    font-size: 15px;
                    color: #ffffff;
                    letter-spacing: 2px;
                  "
                  >Login</span
                >
              </v-flex>
              <v-flex xs12 pt-2>
                <v-divider color="#fff"></v-divider>
              </v-flex>
            </v-layout>
          </router-link>
        </v-flex>
        <v-flex
          v-if="appLogin"
          xs12
          text-center
          pa-2
          pl-4
          text-uppercase
          align-self-center
        >
          <v-layout wrap justify-center>
            <v-flex xs12 @click="appLogout">
              <span
                style="
                  font-family: ibmlight;
                  font-size: 15px;
                  color: #ffffff;
                  letter-spacing: 2px;
                "
                >Logout</span
              >
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>

    <v-app-bar
      app
      dark
      color="#ffffff"
      dense
      flat
      height="50px"
      class="hidden-lg-and-up"
      elevation="1"
    >
      <v-app-bar-nav-icon @click.native="sideNav = !sideNav">
        <v-icon color="#3EA56E">mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to="/">
          <v-layout wrap justify-center>
            <v-flex xs12>
              <!-- <v-img
                src="./../../assets/logoBeta.png"
                height="25px"
                contain
              ></v-img> -->
              <span class="ibmbold cblack">KL 06</span>
            </v-flex>
          </v-layout>
        </router-link>
      </v-toolbar-title>
      <v-app-bar-nav-icon
        v-if="appType == 'Client'"
        class="hidden-lg-and-up"
        @click.native="sideNav2 = !sideNav2"
      >
        <v-icon color="#ff0000">mdi-account</v-icon>
      </v-app-bar-nav-icon>
    </v-app-bar>
    <v-app-bar
      color="#ffffff"
      elevation="1"
      height="70px"
      class="hidden-md-and-down"
    >
      <v-layout wrap justify-center>
        <v-flex xs2 align-self-center pr-lg-6 pr-xl-12>
          <router-link to="/">
            <!-- <v-img
              src="./../../assets/logoBeta.png"
              height="60px"
              contain
            ></v-img> -->
            <span class="ibmbold large cblack">KL 06</span>
          </router-link>
        </v-flex>
        <v-flex xs4 text-left align-self-center v-if="appType == 'Client'">
          <v-layout wrap justify-center>
            <v-flex v-for="(item, i) in categories" :key="i" text-center>
              <span
                style="
                  font-family: ibmsemibold;
                  font-size: 14px;
                  cursor: pointer;
                  color: #545454;
                "
                v-if="
                  item.name == 'Men' ||
                  item.name == 'Women' ||
                  item.name == 'Kids' ||
                  item.name == 'Offer' ||
                  item.name == 'Onam Sale'
                "
                @click="changeRoute(item)"
                >{{ item.name }}
              </span>
              <router-link v-else :to="'/' + item.name">
                <span
                  style="
                    font-family: ibmsemibold;
                    font-size: 14px;
                    cursor: pointer;
                    color: #545454;
                  "
                  >{{ item.name }}
                </span>
              </router-link>
              <v-layout
                wrap
                justify-center
                fill-height
                v-if="
                  $route.query.category == item._id ||
                  $route.path == '/' + item.name ||
                  $route.query.type == item.name
                "
              >
                <v-flex xs10 align-self-center>
                  <v-progress-linear
                    value="100"
                    color="#FF4343"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs4 text-left align-self-center v-if="appType == 'Seller'">
          <v-layout wrap justify-center fill-height>
            <v-flex xs12 text-left align-self-end>
              <span style="font-family: ibmbold; font-size: 18px">
                <!-- {{ appUser.firstname }} -->
                <!-- {{ appUser.lastname }} -->
                {{ appUser.organization }}
              </span>
            </v-flex>
            <v-flex xs12 text-left align-self-start>
              <span style="font-family: ibmlight; font-size: 15px">
                {{ appUser.city }}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-spacer></v-spacer>
        <!-- <v-flex xs2 lg2 xl1 align-self-center>
          <v-form @submit.prevent="appSearch">
            <v-text-field
              class="searchBox"
              v-model="searchKey"
              prepend-inner-icon="mdi-magnify"
              placeholder="Search for products"
              solo
              flat
              hide-details
              color="#FF0F0F"
            ></v-text-field>
          </v-form>
        </v-flex> -->
        <v-flex xs6 lg2 xl2 v-if="appType == 'Client'" align-self-center>
          <AccountMenu />
        </v-flex>
        <v-flex xs6 lg2 v-if="appType == 'Seller'">
          <v-layout wrap justify-center v-if="appUser">
            <v-flex xs3 v-if="appUser.image">
              <v-avatar>
                <v-img :src="mediaURL + appUser.image">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#3EA56E"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap justify-center fill-height>
                <v-flex xs12 text-left align-self-end>
                  <span style="font-family: opensansbold; font-size: 15px">
                    {{ appUser.firstname }}
                    {{ appUser.lastname }}
                  </span>
                </v-flex>
                <v-flex xs12 text-left align-self-start>
                  <span
                    @click="appLogout"
                    style="
                      cursor: pointer;
                      font-family: opensanssemibold;
                      font-size: 13px;
                      color: #979696;
                    "
                  >
                    Log Out
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app-bar>
  </div>
</template>
<script>
import AccountMenu from "./accountMenu";
export default {
  components: {
    AccountMenu,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      sideNav: false,
      sideNav2: false,
      user: {},
      navItems: [
        { name: "Wishlist", route: "/Wishlist", type: "link" },
        { name: "Cart", route: "/Cart", type: "link" },
        { name: "Profile", route: "/Profile", type: "link" },
      ],
      sellerNavItems: [
        { name: "ANALYTICS", route: "/Seller" },
        { name: "ADD A PRODUCT", route: "/Seller/AddProduct" },
        { name: "PRODUCT SOLD", route: "/Seller/SoldProducts" },
        { name: "PENDING ORDERS", route: "/Seller/PendingOrders" },
        { name: "OFFERS", route: "/Seller/Offers" },
        { name: "INVENTORY", route: "/Seller/Inventory" },
        { name: "PROFILE", route: "/Seller/Profile" },
      ],
      userName: null,
      profilePic: null,
      cartItems: 0,
      searchKey: null,
    };
  },
  beforeMount() {
    this.searchKey = this.$route.query.searchKey;
    this.$store.dispatch("getCategory");
    this.$store.dispatch("getStylCategory");
  },
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appType() {
      return this.$store.state.userType;
    },
    categories() {
      return this.$store.state.categories.data;
    },
    stylCategories() {
      return this.$store.state.stylCategories;
    },
  },

  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
      if (this.sideNav2 == true) {
        this.sideNav2 = false;
      }
    },
    changeRoute(item) {
      if (item.name != "Offer") {
        this.$router.push({
          path: "/Products",
          query: {
            styl: this.$route.query.styl,
            category: this.$route.query.category != item._id ? item._id : null,
            // subcategory: this.$route.query.subcategory,
            searchKey: this.$route.query.searchKey,
            type: this.$route.query.type,
          },
        });
      } else {
        this.$router.push({
          path: "/Products",
          query: {
            styl: this.$route.query.styl,
            // subcategory: this.$route.query.subcategory,
            searchKey: this.$route.query.searchKey,
            type: this.$route.query.type != item.name ? item.name : null,
          },
        });
      }
    },
    changeStylRoute(item) {
      this.$router.push({
        path: "/Products",
        query: {
          styl: this.$route.query.styl != item._id ? item._id : null,
          category: this.$route.query.category,
          subcategory: this.$route.query.subcategory,
          searchKey: this.$route.query.searchKey,
          type: this.$route.query.type,
        },
      });
    },
    appSearch() {
      if (this.appType == "Client") {
        if (this.$route.query.searchKey != this.searchKey) {
          this.$router.push({
            path: "/Products",
            query: {
              styl: this.$route.query.styl,
              category: this.$route.query.category,
              subcategory: this.$route.query.subcategory,
              searchKey: this.searchKey,
              type: this.$route.query.type,
            },
          });
        } else {
          return;
        }
      } else {
        if (this.$route.query.searchKey != this.searchKey) {
          this.$router.push({
            path: "/Seller/Inventory",
            query: {
              searchKey: this.searchKey,
            },
          });
        } else {
          return;
        }
      }
    },
  },
};
</script>

<style>
input::-webkit-input-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: ibmregular !important;
}
input::-moz-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: ibmregular !important;
}
.searchBox .v-input__control {
  min-height: 10px !important;
}
.searchBox .v-input__control .v-input__slot {
  padding: 0px !important;
}
</style>

